import React from "react";
import Template from "../components/Template";

const SignUp = ({setIsLoggedIn}) => {
    return (
        <Template   
            formtype="signup"
        />
    )
} 
export default SignUp